import styles from "./campain.module.css";
import { FaStopCircle } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { BsStarHalf } from "react-icons/bs";
import { RiDeleteBack2Line } from "react-icons/ri";
import ReactTooltip from "react-tooltip";
import Modal from "./modal/Modal";
import Acordion from "./Acordion";
const BoxClue = ({
  item,
  deleteHandler,
  index,
  customers,
  setCustomers,
  setSelectedItem,
}) => {
  const editHandler = () => {
    setSelectedItem(index);
    console.log(index);
  };
  const stopHandler = () => {
    setSelectedItem(index);
    console.log(index);
  };
  return (
    <div
      className={`  w-100  ${styles.sec}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className={`d-flex flex-wrap ${styles.secondry}`}>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عنوان کمپین
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.title}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            نام مشتری
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.name}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            شماره تماس مشتری{" "}
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.mobile}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تاریخ ثبت
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.registerTime}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تاریخ اولین پیگیری
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.startTime}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            تاریخ آخرین پیگیری
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.endTime}{" "}
          </p>
        </div>
        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            آخرین وضعیت
          </p>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            {item.lastStatus}{" "}
          </p>
        </div>

        <div className={styles.BlueCol}>
          <p
            className={` d-flex justify-content-center align-items-center ${styles.blueRow}`}
          >
            عملیات{" "}
          </p>
          <div
            className={` d-flex justify-content-center align-items-center ${styles.nameRow}`}
          >
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModaldel`}
              onClick={stopHandler}
            >
              <h4 data-tip="حذف سرنخ">
                <RiDeleteBack2Line className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
            <p
              className={styles.tlg}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal`}
              onClick={editHandler}
            >
              <h4 data-tip="ویرایش سرنخ">
                <FiEdit className={styles.tlg1} />
              </h4>
              <ReactTooltip />
            </p>
          </div>
        </div>
      </div>

      <Acordion index={index} />
    </div>
  );
};

export default BoxClue;
